import "core-js/modules/es.object.to-string.js";
import { matchPath, useLocation } from 'react-router-dom';
import config from 'utils/config';
import { PROFILE_ROUTES } from 'utils/routes';
import { useFetchUserMindsetSettings } from 'actions/userProfile';
import { useFetchUserHelixAccess } from 'actions/users';
var PROFILE_SKILLS_ROUTES = [PROFILE_ROUTES.skills, PROFILE_ROUTES.skillsSkill, PROFILE_ROUTES.skillsMeeting];
export function useCheckIfWeShowAgentInPage() {
  var _useFetchUserMindsetS = useFetchUserMindsetSettings(),
    hasMindsetAgent = _useFetchUserMindsetS.hasMindsetAgent,
    isMindsetSettingsLoading = _useFetchUserMindsetS.isLoading;
  var _useFetchUserHelixAcc = useFetchUserHelixAccess(),
    helixAccessData = _useFetchUserHelixAcc.data,
    isHelixAccessLoading = _useFetchUserHelixAcc.isLoading;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var isOnRouteWhichShouldShowAgent = PROFILE_SKILLS_ROUTES.some(function (route) {
    return !!matchPath({
      path: route,
      end: false
    }, pathname);
  });
  return {
    hasAgentOnPage: Boolean(config.showAgentInHelixPages && hasMindsetAgent && (helixAccessData === null || helixAccessData === void 0 ? void 0 : helixAccessData.isHelixHub) && isOnRouteWhichShouldShowAgent),
    isSettled: !isMindsetSettingsLoading && !isHelixAccessLoading
  };
}
export default useCheckIfWeShowAgentInPage;